import React, { Component, Fragment } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as ChannelsActions } from 'store/ducks/channels';

import { Access } from 'common';
import { Page, Panel, Loading, Pagination, Breadcrumbs } from 'components';

class List extends Component {
  state = {
    breadcrumbs: [{ name: 'Home', to: '/' }, { name: 'Pontos', to: '/points' }, { name: 'Canais', to: '' }],
  };

  componentDidMount() {
    const { location, getChannelsRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    getChannelsRequest(page);
  }

  componentDidUpdate(oldProps) {
    const { location, getChannelsRequest } = this.props;

    if (queryString.parse(oldProps.location.search).page !== queryString.parse(location.search).page) {
      getChannelsRequest(queryString.parse(location.search).page);
    }
  }

  render() {
    const { breadcrumbs } = this.state;
    const { channels } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Lista de Canais</Page.Title>

        <Panel className="panel-list">
          {!channels.data.length && channels.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {channels.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th className="big-size">canal</th>
                    <th>ativo</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>
                <tbody>
                  {!channels.data.length && (
                    <tr>
                      <td colSpan="3" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {channels.data.map((channel, index) => (
                    <tr key={channel.id}>
                      <td>{channel.attributes.name}</td>
                      <td className={channel.attributes.score ? 'label-active' : 'label-inactive'}>
                        {channel.attributes.score ? 'Sim' : 'Não'}
                      </td>
                      <td className="text-right">
                        {Access.hasPermissions('edit-channels') && (
                          <Link to={`/points/channels/${channel.id}/edit`} className="button-icon">
                            <span className="glyph glyph-pencil" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="3" />
                  </tr>
                </tfoot>
              </table>

              <Pagination className="m-t-20" current={channels.page} total={channels.totals} {...this.props} />
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  channels: state.channels,
});

const mapActions = dispatch => bindActionCreators(ChannelsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(List);
